module.exports = __webpack_public_path__ + "static/media/top-slide-4.44acf5aa.avif";